import React, { useState } from 'react'

// Material UI
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Drawer from '@material-ui/core/Drawer'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

//
import { emphasize, withStyles } from '@material-ui/core/styles'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import Chip from '@material-ui/core/Chip'
import HomeIcon from '@material-ui/icons/Home'

// Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'

// Components
import Item from '../Item/Item'

// CSS
import './MenuCategory.css'

// Redux
import { connect } from 'react-redux'

const StyledBreadcrumb = withStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.grey[100],
        top: 10,
        height: theme.spacing(6),
        color: theme.palette.grey[800],
        fontWeight: theme.typography.fontWeightRegular,
        '&:hover, &:focus': {
            backgroundColor: theme.palette.grey[300],
        },
        '&:active': {
            boxShadow: theme.shadows[1],
            backgroundColor: emphasize(theme.palette.grey[300], 0.12),
        },
    },
}))(Chip)

const MenuCategory = ({ data, clientData, menuData }) => {

    const { client } = clientData
    const { menu } = menuData

    const categories = menu.Categories
    const styles = { alignItems: "baseline" }

    const getCategories = (UID) => {
        return (categories.find(category => {
            return (
                category["UID"] === UID &&
                category["Online_Disable"] === false &&
                category[client.diningView] === true
            )
        }))
    }

    const getSubCategories = (UID) => {
        return (categories.filter(category => {
            return (
                category.Parent_UID === UID &&
                category["Online_Disable"] === false &&
                category[client.diningView] === true
            )
        }))
    }

    const [item, setItem] = useState()
    const [openDrawer, setOpenDrawer] = useState(false)
    const [breadCrumb, setBreadCrumb] = useState([{ Name: data.Name, UID: data.UID }])
    const [categoryItems, setCategoryItems] = useState(data.Items)
    const [subCategories, setSubCategories] = useState(() => {
        const initialState = getSubCategories(data.UID)
        return initialState
    })

    if (categoryItems === undefined) {
        return <>No Data... </>
    }

    if (subCategories === undefined) {
        return <>No Data... </>
    }

    const handleSubCatClick = (category) => {

        const { UID, Name } = category

        let categories = getCategories(UID)
        let subCategory = getSubCategories(UID)

        if (categories && subCategory.length === 0) {
            setCategoryItems(categories.Items)
            setSubCategories([])
        }

        if (categories.length === 0 && subCategory) {
            setCategoryItems([])
            setSubCategories(subCategory)
        }

        if (categories.length !== 0 && subCategory.length !== 0) {
            setCategoryItems(categories.Items)
            setSubCategories(subCategory)
        }

        let breadIndex = breadCrumb.findIndex(i => i.UID === UID)

        if (breadIndex >= 1)
            setBreadCrumb(breadCrumb.slice(0, breadIndex + 1))

        if (breadIndex === 0)
            setBreadCrumb(breadCrumb.slice(0, 1))

        if (breadIndex === -1)
            setBreadCrumb([...breadCrumb, { Name: Name, UID: UID }])

    }

    const toggleDrawer = (item) => {
        setOpenDrawer(!openDrawer)
        if (item) setItem(item)
    }

    const RenderCategoryItems = () => {

        return (
            categoryItems.map((item) =>
                <Card key={item.UID} onClick={() => toggleDrawer(item)} className="card">
                    <CardContent className="card_info">
                        <Grid justify="space-between" container style={styles}>
                            <Grid item>
                                <Typography variant="subtitle1">{item.Name}</Typography>
                            </Grid>
                            <Grid item>
                                <Typography variant="subtitle1">{item[client.diningOption] === 0 ? item.Price.toFixed(2) : item[client.diningOption].toFixed(2)}$</Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            )
        )
    }

    const RenderSubCategory = () => {
        return (
            subCategories.map((category) =>
                <Card onClick={() => handleSubCatClick(category)} key={category.UID} className="card">
                    <CardContent className="card_info ">
                        <Grid justify="space-between" container>
                            <Grid item>
                                <Typography variant="subtitle1">{category.Name}</Typography>
                            </Grid>
                            <Grid item>
                                <ArrowForwardIosIcon />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            )
        )
    }

    return (
        <>
            {breadCrumb.length > 1 &&
                <>
                    <Breadcrumbs aria-label="breadcrumb">
                        {breadCrumb.map((breadCrumb, index, arr) => {
                            return (
                                <div key={index}>
                                    {index === 0
                                        ?
                                        <StyledBreadcrumb
                                            component="a"
                                            label={breadCrumb.Name}
                                            icon={<HomeIcon fontSize="small" />}
                                            onClick={() => handleSubCatClick(breadCrumb)}
                                        />
                                        :
                                        arr.length - 1 === index
                                            ?
                                            <StyledBreadcrumb
                                                component="a"
                                                label={breadCrumb.Name}
                                                aria-current="page"
                                            />
                                            :
                                            < StyledBreadcrumb
                                                component="a"
                                                label={breadCrumb.Name}
                                                onClick={() => handleSubCatClick(breadCrumb)}
                                            />
                                    }
                                </div>
                            )
                        })
                        }
                    </Breadcrumbs>
                </>
            }

            {categoryItems.length !== 0 &&
                <RenderCategoryItems />
            }

            {subCategories.length !== 0 &&
                < RenderSubCategory />
            }

            <Drawer open={openDrawer} anchor="right">
                <Item item={item} toggleDrawer={toggleDrawer} />
            </Drawer>
        </>
    )
}

const mapStateToProps = state => {
    return {
        clientData: state.clientData,
        menuData: state.menuData
    }
}

export default connect(mapStateToProps)(MenuCategory)